module.exports = __webpack_public_path__ + "img/italian-style-spaghetti-squash-bake.6d58acb0.jpg";